var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-24bdc378-1704-43e4-968c-59fa52765128",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-afb927d7-31ac-4c70-b737-e4085cbf91dc {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-afb927d7-31ac-4c70-b737-e4085cbf91dc",
    d: "M15.37,22.42l-2.42-3.23-1.7,2.59c-.3.46-.92.59-1.38.29-.46-.3-.59-.92-.29-1.38l3.26-4.97,2.31,3.08,3.82-6.64,3.51,7.04c.25.49.05,1.09-.45,1.34-.49.25-1.09.05-1.34-.45l-1.85-3.7-3.47,6.04Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-afb927d7-31ac-4c70-b737-e4085cbf91dc",
    cx: 11.86,
    cy: 11.62,
    r: 2.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.330d266d67c445466c18c6bb9a2d3ae4.svg";
export { ForwardRef as ReactComponent };